module.exports = __webpack_public_path__ + "media/bensound-betterdays.277ade9e.mp3";